document.addEventListener("DOMContentLoaded", function(){
    console.log(`%c sc-staging.js START`, `color: red; font-weight:bold; background-color: yellow;`);

    function trimChar(str, char) {
        const escapedChar = char.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regex = new RegExp(`^${escapedChar}+|${escapedChar}+$`, 'g');
        return str.replace(regex, '');
    }    

    function handleize(input) {
        return trimChar(input
            .trim()
            .toLowerCase()
            .normalize("NFD").replace(/[̀-ͯ]/g, "")
            .replace(/[^a-z0-9]+/g, "-"), '-');
    }    

    async function keepOptionsForSparenTab(){
        console.log(`%c keepOptionsForSparenTab(){`, `color: red; font-weight:bold; background-color: green;`);

        return new Promise((resolve, reject) => {
            try {
                const deliveryTabs = document.getElementById('deliveryTabs');
                if(deliveryTabs){
                    const keepOptionsString = deliveryTabs?.getAttribute('data-keep-options');
                    console.dir(`keepOptionsString`);console.dir(keepOptionsString);

                    const keepOptions = keepOptionsString?.split(',');
                    console.dir(`keepOptions`);console.dir(keepOptions);

                    keepOptions.forEach((groupValueString) => {
                        console.log(`%c keepOptions.forEach((groupValueString) => {`, `color: red; font-weight:bold; background-color: yellow;`);

                        const optionGroupName = groupValueString.split(':')[0];
                        const optionValueToKeep = groupValueString.split(':')[1].trim();

                        const optionGroupHandle = handleize(optionGroupName);
                        console.dir(`optionGroupHandle`);console.dir(optionGroupHandle);

                        const optionGroupSelector = `fieldset[data-handle="${optionGroupHandle}"]`
                        const fieldset = document.querySelector(optionGroupSelector);
                        const variantInputDivs = fieldset ? fieldset.querySelectorAll('div.variant-input') : [];

                        variantInputDivs.forEach((variantInputDiv) => {
                            console.dir(`variantInputDivs.forEach((variantInputDiv) => {`);

                            let optionValue = variantInputDiv.getAttribute('data-value').trim();
                            
                            if(!variantInputDiv.classList.contains('sc-cloned') && optionValue !== optionValueToKeep){
                                console.dir(`if(!variantInputDiv.classList.contains('sc-cloned') && optionValue !== optionValueToKeep){`);
                                variantInputDiv.classList.add('hide-dom');
                            }
                        });

                        const variantInputDivToSelect = fieldset ? fieldset.querySelector(`div.variant-input[data-value="${optionValueToKeep}"]`) : null;
                        const labelToSelect = variantInputDivToSelect?.querySelector('label');
                        labelToSelect?.click();
                    });

                    setTimeout(() => {
                        hideRcWidget();
                        console.log(`%c keepOptionsForSparenTab() resolve`, `color: red; font-weight:bold; background-color: yellow;`);
                        resolve();
                    }, 0);
                } 
                else {
                    reject('deliveryTabs not found.');
                }
            }
            catch (error) {
                reject(`keepOptionsForSparenTab catch error: ${error}`);
            }
        });
    }

    async function showAllDefaultUnclonedOptions(){
        const fieldsetElements = document.querySelectorAll('fieldset');
        fieldsetElements.forEach((fieldset) => {
            const variantInputDivs = fieldset.querySelectorAll('div.variant-input');
            variantInputDivs.forEach((variantInputDiv) => {
                if(!variantInputDiv.classList.contains('sc-cloned')){
                    variantInputDiv.classList.remove('hide-dom');
                }
            });
        });
    }

    function extractPrice(input) {
        const cleanedInput = input.replace(/[^\d.,]/g, '');
        const standardizedInput = cleanedInput.replace(',', '.');
        return parseFloat(standardizedInput);
    }

    function roundToTwoDecimalPlaces(num) {
        return Math.round(num * 100) / 100;
    }

    function formatPrice(price) {
        return price.toFixed(2).replace('.', ',') + '€';
    }

    function parseValueFromPrice(str) {
        let numericPart = str.trim().replace(',', '.').match(/\d+(\.\d+)?/);
        return numericPart ? parseFloat(numericPart[0]) : NaN;
    }

    function getDiscountFromAppWidget(tab){
        console.log(`%c function getDiscountFromAppWidget(){`, `color: red; font-weight:bold; background-color: yellow;`);

        const discountBadge = tab.querySelector('.discount-badge');
        let discountString = discountBadge?.textContent;
        let discount = discountString ? parseValueFromPrice(discountString) : 0;

        const subscribeLabel = document.querySelector('label.subscription-radio');
        if(subscribeLabel){
            const discountLabel = subscribeLabel.querySelector('.discount-label');
            discountString = discountLabel?.textContent;
            discount = discountString ? parseValueFromPrice(discountString) : discount;
        }
        console.log(`%c discount`, `color: red; font-weight:bold; background-color: yellow;`);
        console.dir(discount);

        return discount;
    }
    
    async function setPriceBySelectedTab(labelFor, discount=0){
        console.log(`%c async function setPriceBySelectedTab(labelFor){`, `color: red; font-weight:bold; background-color: yellow;`);
        console.dir(`labelFor`);console.dir(labelFor);

        let labelSelector = 'label.subscription-radio';
        if(labelFor === 'rc-radio2'){
            labelSelector = 'label.subscription-radio';
        } else {
            labelSelector = 'label.onetime-radio';
        }
      
        const label = document.querySelector(labelSelector);
        console.dir(`label`);console.dir(label);

        const priceLabel = label.querySelector('.price-label');
        const price = priceLabel.textContent.trim();
        const productPriceElement = document.querySelector('form[action="/cart/add"] .product-block--price .product-price-container .product__price:not(.product__price--compare)');
        productPriceElement.textContent = price;

        const originalPrice = productPriceElement.getAttribute('data-original-price').trim();
        const comparePriceWrapper = document.querySelector('form[action="/cart/add"] .product-block--price .product-price-container span[data-product-price-wrap]');
        const comparePriceElement = comparePriceWrapper.querySelector('.product__price--compare');
        if(labelFor === 'rc-radio2'){
            if(price != originalPrice){
                comparePriceElement.textContent = originalPrice;
                comparePriceWrapper.classList.remove('hide');
            }
        } else {
            comparePriceWrapper.classList.add('hide');
        }

        // //old
        // //change kg price
        // let digitPrice = extractPrice(price);
        // let pricePerKg = roundToTwoDecimalPlaces(digitPrice * 2);//problem here
        // let formatedPricePerKg = formatPrice(pricePerKg);
        // let unitPriceSpan = document.querySelector('form[action="/cart/add"] .product-block--price .product-price-container .product__unit-price span[data-unit-price]');
        // unitPriceSpan.textContent = formatedPricePerKg;

         let unitPriceSpan = document.querySelector('form[action="/cart/add"] .product-block--price .product-price-container .product__unit-price span[data-unit-price]');
         let defaultUnitPriceValue = unitPriceSpan.getAttribute('data-unit-price-value');
 
         if(discount > 0){
             let defaultPricePerKg = parseValueFromPrice(defaultUnitPriceValue);
             let pricePerKg = defaultPricePerKg * (1 - discount / 100);
             let formatedPricePerKg = formatPrice(pricePerKg);
             unitPriceSpan.textContent = formatedPricePerKg;
         } else {
             unitPriceSpan.textContent = defaultUnitPriceValue;
         }
    }

    async function simulateClick(labelFor) {
        console.log(`%c async function simulateClick(labelFor) {`, `color: red; font-weight:bold; background-color: yellow;`);

        return new Promise((resolve, reject) => {
            try {
                let labelSelector = 'label.subscription-radio';
                if (labelFor === 'rc-radio2') {
                    labelSelector = 'label.subscription-radio';
                } else {
                    labelSelector = 'label.onetime-radio';
                }

                const label = document.querySelector(labelSelector);
                console.dir(`label`);console.dir(label);

                if (label) {
                    label.click();
                    setTimeout(() => {
                        console.log(`%c Sucsess click!`, `color: red; font-weight:bold; background-color: yellow;`);
                        resolve();
                    }, 0);
                } else {
                    reject(`Label for="${labelFor}" not found.`);
                }
            } catch (error) {
                reject(`simulateClick catch error: ${error}`);
            }
        });
    }
    
    
    function isUrlVariablePresent(variable) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.has(variable);
    }
 
    const oneTimePurchaseTab = document.getElementById('one-time-purchase-tab');
    const subscribeSaveTab = document.getElementById('subscribe-save-tab');

    const deliveryBenefits = document.querySelector('.delivery-benefits')
    const oneTimePurchase = document.querySelector('.onetime-purchase-note')

    const hoverBackground = document.querySelector(".tab-hover-background")                      

    oneTimePurchaseTab.addEventListener('click', async () => {
        
        await simulateClick('rc-radio1');

        await copyPlansSelect(false);

        showAllDefaultUnclonedOptions();
        setTimeout(async () => {
            await setPriceBySelectedTab('rc-radio1', 0);
        }, 0);

        hoverBackground.style.left = '0%'

        oneTimePurchaseTab.classList.add('active');
        subscribeSaveTab.classList.remove('active');

        deliveryBenefits.classList.add("hidden")
        oneTimePurchase.classList.remove("hidden")

    });

    subscribeSaveTab.addEventListener('click', async () => {
        console.dir(`subscribeSaveTab.addEventListener('click', async () => {`);
        
        await keepOptionsForSparenTab();

        await simulateClick('rc-radio2');

        await copyPlansSelect(true);

        const discount = getDiscountFromAppWidget(subscribeSaveTab);

        setTimeout(async () => {
            await setPriceBySelectedTab('rc-radio2', discount);
        }, 0);

        hoverBackground.style.left = '50%';
        subscribeSaveTab.classList.add('active');
        oneTimePurchaseTab.classList.remove('active');

        deliveryBenefits.classList.remove("hidden")
        oneTimePurchase.classList.add("hidden")
    });

    async function copyPlansSelect(need_clone = true) {
        let clonedSelect = document.querySelector('.sc-cloned-select');
        if (clonedSelect) {
            clonedSelect.remove();
        }

        if(need_clone){
            setTimeout(() => {
                let selectElement = document.querySelector('.rc-selling-plans-dropdown__select');
                if (selectElement) {
                    
                    clonedSelect = selectElement.cloneNode(true);
                    clonedSelect.classList.add('sc-cloned-select');
                    clonedSelect.setAttribute('id', 'sc-cloned-select');
                    clonedSelect.classList.remove('rc-selling-plans-dropdown__select');
                    let buyButtonContainer = document.querySelector('.buy_button-container');
                    if (buyButtonContainer) {
                        buyButtonContainer.parentNode.insertBefore(clonedSelect, buyButtonContainer);
                        clonedSelect.addEventListener('change', function() {
                            selectElement.value = clonedSelect.value;
                            let event = new Event('change', { bubbles: true });
                            selectElement.dispatchEvent(event);
                        });
                    }
                }
            }, 0);
        }
    }

    function hideRcWidget(withClick = false) {
        var checkExist = setInterval(async function() {
        if (document.querySelector('.rc-widget')) {
            document.querySelector('.rc-widget').classList.add('hidden');
            document.querySelector(".delivery-tab .loader")?.remove()
            subscribeSaveTab.classList.remove('sc-disabled');
            if (isUrlVariablePresent('selling_plan') && withClick) {
                subscribeSaveTab.click();
            } 

            const fieldsetElements = document.querySelectorAll('fieldset.sc-op-0');
            fieldsetElements.forEach((fieldsetElement) => {
                fieldsetElement.classList.remove('sc-op-0');
            });
            clearInterval(checkExist);
        }
        }, 100);
    }
    hideRcWidget(true);

    console.log(`%c sc-staging.js END v5.11`, `color: red; font-weight:bold; background-color: yellow;`);
});

window.addEventListener('load', (event) => {

    const fieldsetElements = document.querySelectorAll('fieldset.sc-op-0');
    fieldsetElements.forEach((fieldsetElement) => {
        fieldsetElement.classList.remove('sc-op-0');
    });
});